import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Switch, Case, Default } from '@ers/ui';
import { useSelectorWithDispatch } from '@ers/hooks/';
import { getOffer as getOfferSelector } from './offer.selectors';
import { fetchJobOfferLink } from './offer.actions';
import { NoOffer, OfferAddForm, OfferDeleteForm, OfferPreview } from '.';


const useOfferStateManager = (isAdded) => {
    const [state, setter] = useState(isAdded ? 2 : 0);
    useEffect(() => {
        setter(isAdded ? 2 : 0);
    }, [isAdded]);
    const states = {
        empty: 'empty',
        adding: 'adding',
        added: 'added',
        deleting: 'deleting'
    };
    const { empty, adding, added, deleting } = states;
    const cycle = [empty, adding, added, deleting];
    const nextState = () => setter((state + 1) % cycle.length);
    const prevState = () => setter((state + cycle.length - 1) % cycle.length);
    const isStep = (step) => cycle.indexOf(step) === state;

    // finish manager here
    return { nextState, prevState, isStep };
};
const Offer = ({ applicationId }) => {
    const getOffer = (state) => getOfferSelector(state, { applicationId });
    const offer = useSelectorWithDispatch(getOffer, () => fetchJobOfferLink(applicationId), (o) => o === undefined);
    const { isStep, nextState, prevState } = useOfferStateManager(Boolean(offer));
    return (
        <Switch expression={Boolean(offer)}>
            <Case condition={(o) => !o && isStep('adding')}>
                <OfferAddForm nextState={nextState} prevState={prevState} applicationId={applicationId} />
            </Case>
            <Case condition={(o) => o && isStep('added')}>
                <OfferPreview
                    nextState={nextState} prevState={prevState} applicationId={applicationId}
                    offer={offer}
                />
            </Case>
            <Case condition={(o) => o && isStep('deleting')}>
                <OfferDeleteForm nextState={nextState} prevState={prevState} applicationId={applicationId} />
            </Case>
            <Default>
                <NoOffer nextState={nextState} prevState={prevState} />
            </Default>
        </Switch>
    );
};

Offer.propTypes = {
    applicationId: PropTypes.number.isRequired
};

export const StateManagerProps = {
    prevState: PropTypes.func.isRequired,
    nextState: PropTypes.func.isRequired,
    offer: PropTypes.object,
    applicationId: PropTypes.number
};

export default Offer;
